export default "__VITE_ASSET__D11j_CUN__"